import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccessUserInfo } from 'src/app/models';

@Component({
  selector: 'bart-equipment-menu',
  templateUrl: './equipment-menu.component.html',
  styleUrls: ['./equipment-menu.component.scss']
})
export class EquipmentMenuComponent implements OnInit {
  userDetail :any  =null;
  public bartRoleCode: string="";
  public activeLink = '';

  constructor(private router: Router) { }
  ngOnInit() {
    this.activeLink = this.router.url;
    this.userDetail = AccessUserInfo.getUserInfo();
    this.bartRoleCode=this.userDetail.bartRoleCode;
  }

  navigateToSearchEquipment(event) {
    event.preventDefault();
    this.router.navigateByUrl('/', {skipLocationChange: true})
    .then(() => this.router.navigate(['/equipment/searchEquipment']));
  }

  navigateToAddEquipment(event) {
    event.preventDefault();
    this.router.navigateByUrl('/', {skipLocationChange: true})
    .then(() => this.router.navigate(['/equipment/AddEquipment']));
  }

  navigateToManageoem(event) {
    event.preventDefault();
    this.router.navigateByUrl('/', {skipLocationChange: true})
    .then(() => this.router.navigate(['/equipment/Manageoem']));
  }

  navigateToMassTransfer(event) {
    event.preventDefault();
    this.router.navigateByUrl('/', {skipLocationChange: true})
    .then(() => this.router.navigate(['/equipment/MassTransfer']));
  }

  navigateToMassUpdate(event) {
    event.preventDefault();
    this.router.navigateByUrl('/', {skipLocationChange: true})
    .then(() => this.router.navigate(['/equipment/MassUpdate']));
  }

  navigateToNameManager(event) {
    event.preventDefault();
    this.router.navigateByUrl('/', {skipLocationChange: true})
    .then(() => this.router.navigate(['/equipment/NameManager']));
  }
}
